import { supabase } from "../supabase";
import { profileRowToUserPreferences } from "./userPreferences";

export async function loadProfilePreferencesForActor(actor, client = supabase) {
  if (!actor?.profile_id && !actor?.supabase_user_id) {
    return null;
  }

  let query = client.from("profiles").select("id, preferences");

  if (actor.profile_id) {
    query = query.eq("id", actor.profile_id);
  } else {
    query = query.eq("supabase_user_id", actor.supabase_user_id);
  }

  const { data, error } = await query.maybeSingle();

  if (error) {
    throw error;
  }

  if (!data) {
    return null;
  }

  return {
    profileId: data.id,
    preferences: profileRowToUserPreferences(data),
  };
}

export async function saveProfilePreferences(profileId, preferences, client = supabase) {
  const { data, error } = await client
    .from("profiles")
    .update({ preferences })
    .eq("id", profileId)
    .select("id, preferences")
    .single();

  if (error) {
    throw error;
  }

  return {
    profileId: data.id,
    preferences: profileRowToUserPreferences(data),
  };
}
